import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { CheckoutModule, PaymentWalletButtonModule } from '@platform-frontend/checkout';
import { MarketplaceAssetModule, SubscriptionPriceUpdateModule } from '@platform-frontend/marketplace';
import {
  ButtonModule,
  CommonWordingModule,
  FormsModule,
  LinkModule,
  LoadingIndicatorModule,
  TemplateVariablesModule,
  TooltipModule
} from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { CommercialCommonModule } from '../commercial-common/commercial-common.module';
import { AddPaymentMethodComponent } from './add-payment-method/add-payment-method.component';
import { BillingAddressSelectionComponent } from './billing-address-selection/billing-address-selection.component';
import { BillingAddressComponent } from './billing-address/billing-address.component';
import { CancelConfirmationComponent } from './cancel-confirmation/cancel-confirmation.component';
import { CancelSubscriptionComponent } from './cancel-subscription/cancel-subscription.component';
import { OverviewComponent } from './overview/overview.component';
import { PaymentMethodSelectionComponent } from './payment-method-selection/payment-method-selection.component';
import { SubscriptionWalletButtonComponent } from './subscription-wallet-button/subscription-wallet-button.component';
import { UpdateConfirmationComponent } from './update-confirmation/update-confirmation.component';

@NgModule({
  declarations: [
    AddPaymentMethodComponent,
    BillingAddressComponent,
    BillingAddressSelectionComponent,
    CancelConfirmationComponent,
    CancelSubscriptionComponent,
    OverviewComponent,
    PaymentMethodSelectionComponent,
    SubscriptionWalletButtonComponent,
    UpdateConfirmationComponent
  ],
  exports: [
    AddPaymentMethodComponent,
    BillingAddressComponent,
    BillingAddressSelectionComponent,
    CancelConfirmationComponent,
    CancelSubscriptionComponent,
    OverviewComponent,
    PaymentMethodSelectionComponent,
    SubscriptionWalletButtonComponent,
    UpdateConfirmationComponent
  ],
  imports: [
    ButtonModule,
    CheckoutModule,
    CommonModule,
    CommonWordingModule,
    CommercialCommonModule,
    FormsModule,
    LinkModule,
    LoadingIndicatorModule,
    MatomoTrackClickDirective,
    MarketplaceAssetModule,
    PaymentWalletButtonModule,
    ReactiveFormsModule,
    RouterExtensionsModule,
    RouterModule,
    SubscriptionPriceUpdateModule,
    TemplateVariablesModule,
    TranslocoMarkupModule,
    TranslocoLocaleModule,
    TranslocoModule,
    TooltipModule
  ]
})
export class SubscriptionManagementModule {}
